module.exports = require("../d") + require("./dupdep");
var ep = "ep";
require("./dupd" + ep);



/*****************
 ** WEBPACK FOOTER
 ** ./compile/deduplication/dedupe1/index.js
 ** module id = 1
 ** module chunks = 0
 **/